<template>
  <div class="field">
    <label for="name"> {{ data.title }} </label>
    <select
      v-on:change="handleChange"
      :name="data.name"
      :type="data.type"
      :value="data.value"
      :disabled="data.disabled"
      required
    >
      <option v-for="option in data.options" :key="option.value" :value="option.value">{{ option.label }}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: ["data", "onChange"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleChange(e) {
      console.log('change e', e.target.value)
      if (this.onChange) this.onChange(e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;

  label {
    font-size: 16px;
    font-weight: bolder;
    font-family: $font__main;
    padding-bottom: 10px;
  }

  select {
    max-width: 361px;
    width: 100%;
    height: 49px;
    border: solid 2px;
    border-color: #e6e6e6;
    margin-bottom: 25px;
  }
}
</style>
